interface CatalogPaginationProps {
  page: number;
  hasNextPage: boolean;
  isFetching: boolean;
  onChange: (page: number) => void;
  /** カタログモード・リストモードでナビゲーションの目的語を書き分ける */
  ariaLabel?: string;
}

export const CatalogPagination: React.FunctionComponent<
  CatalogPaginationProps
> = ({
  page,
  hasNextPage,
  isFetching,
  onChange,
  ariaLabel = "カタログのページ移動",
}: CatalogPaginationProps) => (
  <nav aria-label={ariaLabel} className="catalog-pagination">
    <button
      type="button"
      disabled={page <= 1 || isFetching}
      onClick={(): void => onChange(page - 1)}
    >
      前へ
    </button>
    <output aria-live="polite">{page}ページ</output>
    <button
      type="button"
      disabled={!hasNextPage || isFetching}
      onClick={(): void => onChange(page + 1)}
    >
      次へ
    </button>
    {!hasNextPage && <strong>最終ページ</strong>}
  </nav>
);
